import { render, staticRenderFns } from "./delete-property.vue?vue&type=template&id=228e9ae7"
import script from "./delete-property.vue?vue&type=script&lang=js"
export * from "./delete-property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports